import _extends from "@babel/runtime/helpers/extends";
import React, { useContext } from 'react';
import { HashRouter, Route } from 'react-router-dom';
import HyruleNav from './HyruleNav';
import HyruleBody from './HyruleBody';
import HyruleFooter from './HyruleFooter';
import UserContext from '../context/UserContext';
import LocalizationContext from '../context/LocalizationContext';
/**
 * Base HyruleApplication component for generating the general layout of a Hyrule app.
 * Auth data is not handled in this component.
 *
 * @param authState - Auth state provided by useHyruleNav hook
 * @param tabs - Hyrule nav menu tabs
 * @param routes - Hidden Hyrule app routes
 * @param userConfig - User config component
 * @param appName - Name of the app
 * @param defaultPath - Default path to navigate to
 * @param navHeaderCustom - Custom Nav Header component
 * @param loadingCustom - Custom loading component
 * @param loggedOutCustom - Custom logged out component
 * @param language - Current language
 * @param userDropDownItems - Items to render in the User Dropdown Menu
 * @param dropDownMenus - Extra menus to render to the left of the User Dropdown
 */
const BaseHyruleApplication = _ref => {
  let {
    authState,
    tabs,
    routes,
    userConfig,
    appName,
    defaultPath,
    navHeaderCustom,
    loadingCustom,
    logoutCustom,
    language,
    userDropDownItems,
    dropDownMenus
  } = _ref;
  const localizedStrings = useContext(LocalizationContext);
  if (language) {
    localizedStrings.setLanguage(language);
  }
  return /*#__PURE__*/React.createElement(UserContext.Provider, {
    value: authState.userInfo
  }, /*#__PURE__*/React.createElement(HashRouter, null, /*#__PURE__*/React.createElement(Route, {
    render: routeProps => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HyruleNav, _extends({}, routeProps, {
      authenticated: authState.authenticated,
      appName: appName,
      authToken: authState.authToken,
      defaultPath: defaultPath,
      userInfo: authState.userInfo,
      scopes: authState.scopes,
      componentTabs: tabs,
      routeState: authState.routeState,
      navHeaderCustom: navHeaderCustom,
      userConfig: userConfig,
      userDropDownItems: userDropDownItems,
      dropDownMenus: dropDownMenus
    })), /*#__PURE__*/React.createElement(HyruleBody, {
      authState: authState,
      routes: routes,
      loadingCustom: loadingCustom,
      loggedOutCustom: logoutCustom
    }), /*#__PURE__*/React.createElement(HyruleFooter, null))
  })));
};
export default BaseHyruleApplication;